export const slightlyChallengingWords = [
  {
    word: "borrow",
    image: "https://images.unsplash.com/photo-1581090700227-1e8e9f00be94",
    synonyms: ["take", "loan", "obtain temporarily"],
    example: "Can I borrow your charger for a moment?",
    definition: "To take something for a short time and return it later.",
  },
  {
    word: "remind",
    image: "https://images.unsplash.com/photo-1592861956120-3d5b8b3a5a1e",
    synonyms: ["prompt", "bring to mind", "refresh memory"],
    example: "Please remind me to call her tomorrow.",
    definition: "To make someone remember something.",
  },
  {
    word: "prepare",
    image: "https://images.unsplash.com/photo-1610440447046-1ec1e0b69995",
    synonyms: ["get ready", "organize", "plan"],
    example: "She’s preparing for her job interview.",
    definition: "To make ready for use or an event.",
  },
  {
    word: "deliver",
    image: "https://images.unsplash.com/photo-1606326608697-11bc8a57b9c6",
    synonyms: ["bring", "transport", "hand over"],
    example: "They deliver food to your door in 30 minutes.",
    definition: "To take something to a person or place.",
  },
  {
    word: "arrange",
    image: "https://images.unsplash.com/photo-1589830702597-1c996f48f3c4",
    synonyms: ["organize", "schedule", "set up"],
    example: "I arranged a meeting with my manager.",
    definition: "To plan or organize something in advance.",
  },
  {
    word: "attend",
    image: "https://images.unsplash.com/photo-1518609878373-06d740f60d8b",
    synonyms: ["go to", "participate in", "be present at"],
    example: "He attended the conference last week.",
    definition: "To be present at an event or meeting.",
  },
  {
    word: "cancel",
    image: "https://images.unsplash.com/photo-1607746882042-944635dfe10e",
    synonyms: ["call off", "abort", "withdraw"],
    example: "The flight was canceled due to bad weather.",
    definition: "To stop something from happening.",
  },
  {
    word: "suggest",
    image: "https://images.unsplash.com/photo-1615719413546-0a3abfe3521c",
    synonyms: ["recommend", "propose", "advise"],
    example: "Can you suggest a good restaurant nearby?",
    definition: "To offer an idea or plan for others to consider.",
  },
  {
    word: "behave",
    image: "https://images.unsplash.com/photo-1621954521850-b92c88fd558f",
    synonyms: ["act", "conduct oneself", "perform"],
    example: "Please behave during the class.",
    definition: "To act in a particular way, especially properly.",
  },
  {
    word: "improve",
    image: "https://images.unsplash.com/photo-1580894894512-399f1d878362",
    synonyms: ["enhance", "develop", "make better"],
    example: "You need to improve your writing skills.",
    definition: "To make or become better.",
  },
  {
    word: "increase",
    image: "https://images.unsplash.com/photo-1581091012184-0f3b05caa399",
    synonyms: ["raise", "grow", "expand"],
    example: "Prices have increased recently.",
    definition: "To make something become larger or more.",
  },
  {
    word: "reduce",
    image: "https://images.unsplash.com/photo-1614642264761-69012d9d3ff6",
    synonyms: ["decrease", "cut down", "lower"],
    example: "We should reduce our plastic use.",
    definition: "To make smaller in size, amount, or degree.",
  },
  {
    word: "avoid",
    image: "https://images.unsplash.com/photo-1607623814075-fb6ebcf50fb4",
    synonyms: ["stay away from", "prevent", "dodge"],
    example: "Try to avoid eating late at night.",
    definition: "To keep away from something.",
  },
  {
    word: "depend",
    image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f",
    synonyms: ["rely", "count on", "trust"],
    example: "I depend on my calendar to stay organized.",
    definition: "To need someone or something to succeed or survive.",
  },
  {
    word: "describe",
    image: "https://images.unsplash.com/photo-1509223197845-458d87318791",
    synonyms: ["explain", "depict", "detail"],
    example: "Can you describe what he looks like?",
    definition: "To say or write what someone or something is like.",
  },
  {
    word: "mention",
    image: "https://images.unsplash.com/photo-1584697964154-993fdde9ba74",
    synonyms: ["say", "refer to", "bring up"],
    example: "He didn’t mention his trip in the meeting.",
    definition: "To talk about something briefly.",
  },
  {
    word: "achieve",
    image: "https://images.unsplash.com/photo-1614644147722-2a2b9ef59b25",
    synonyms: ["accomplish", "reach", "attain"],
    example: "She achieved her goals through hard work.",
    definition: "To succeed in doing something you worked for.",
  },
  {
    word: "compare",
    image: "https://images.unsplash.com/photo-1532634896-26909d0d8b97",
    synonyms: ["contrast", "measure", "evaluate"],
    example: "Let’s compare the two options before deciding.",
    definition: "To look at similarities and differences.",
  },
  {
    word: "develop",
    image: "https://images.unsplash.com/photo-1549921296-3a6b450e979e",
    synonyms: ["build", "progress", "grow"],
    example: "He developed a new app last year.",
    definition: "To create or improve something over time.",
  },
  {
    word: "promise",
    image: "https://images.unsplash.com/photo-1614206554084-5c85edec4e2b",
    synonyms: ["vow", "pledge", "guarantee"],
    example: "She promised to return the book tomorrow.",
    definition: "To say you will definitely do something.",
  },
  {
    word: "recognize",
    image: "https://images.unsplash.com/photo-1509021436665-8f07dbf5bf1d",
    synonyms: ["identify", "notice", "acknowledge"],
    example: "I didn’t recognize her in the new haircut.",
    definition: "To know someone or something because you've seen it before.",
  },
  {
    word: "suggest",
    image: "https://images.unsplash.com/photo-1581092580498-027b2c1d2c9f",
    synonyms: ["recommend", "propose", "advise"],
    example: "She suggested trying a new place.",
    definition: "To put forward an idea or plan for others to consider.",
  },
  {
    word: "trust",
    image: "https://images.unsplash.com/photo-1609840117091-0e2ed65d5c2a",
    synonyms: ["believe", "rely on", "have confidence in"],
    example: "I trust my best friend completely.",
    definition: "To believe that someone is honest or reliable.",
  },
  {
    word: "wonder",
    image: "https://images.unsplash.com/photo-1529243856184-fd5465488984",
    synonyms: ["think", "question", "doubt"],
    example: "I wonder if she’ll come to the party.",
    definition: "To feel curiosity or doubt about something.",
  },
  {
    word: "warn",
    image: "https://images.unsplash.com/photo-1515586171461-04e207b927f7",
    synonyms: ["alert", "advise", "caution"],
    example: "They warned us about the strong winds.",
    definition: "To tell someone about a possible danger or problem.",
  },
];
